module.exports = __webpack_public_path__ + "img/Support-skill-410.0c37a06c.png";